import React from 'react';
import { PsPage } from '../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../i18n/I18nUtils';
import AttachmentResumeCard from './AttachmentResumeCard';
import { BreadcrumbsManagerInstance } from '../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../shared/breadcrumbs/Breadcrumbs';

export default class AttachmentSummaryScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.removeBreadcrumb(Breadcrumbs.DOCUMENTS_ATTACHMENT);
        BreadcrumbsManagerInstance.addBreadcrumb({
            ...Breadcrumbs.DOCUMENTS_ATTACHMENT_SUMMARY,
            url: props.location.pathname,
        });

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_RESUMEN_DE_SUBIDA_DE_FICHEROS_A_MULTIPLES_DOCUMENTOS')} breadcrumbs={breadcrumbs}>
                <AttachmentResumeCard/>
            </PsPage>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentSummaryScreen.jsx